import { React, useEffect } from "react";

function Search(props) {
  useEffect(() => {
    const script = document.createElement("script");
    var s = document.getElementsByTagName("script")[0];
    script.async = true;
    script.setAttribute("charset", "utf-8");
    script.src =
      "https://cdn.doofinder.com/media/js/doofinder-fullscreen.7.latest.min.js";
    s.parentNode.insertBefore(script, s);
    const script2 = document.createElement("script");
    script2.text =
      'var dfFullscreenLayers = [{"hashid": "' +
      props.cfg.doofinderId +
      '",\
      "zone": "eu1",\
      "display": {\
        "lang": "it"\
      },\
      "toggleInput": "#root > .App > .header_01 > .header_02 > .ricerca > .ico_lente > img"\
    }];';

    s.parentNode.insertBefore(script2, s);
  }, []);

  return <></>;
}

export default Search;
